// extracted by mini-css-extract-plugin
export default {"icon":"freelancers_icon__cg5O+","iconDanger":"freelancers_iconDanger__c++Ku"};